import React, {Component}                     from 'react';
import {BrowserRouter as Router, Route, Link} from "react-router-dom";
import './App.css';
import VXHeader                               from './VXHeader';
import VXFooter                               from './VXFooter';
import RRHeader                               from './RoxxRacingHeader';
import Navi                                   from './Navigation';
import TicketsPage                            from './TicketsPage';
import NewsPage                               from './NewsPage'
import MysteryAuto                            from './img/Mystery-Auto.jpg';
import Category1                              from './img/First-Category.jpg';
import Category2                              from './img/Second-Category.jpg';
import LexyTeaser                             from './img/Lexy-360-Teaser-1300.jpg';
import AutoInterior                           from './img/Auto-Promo.jpg';
import AutoInteriorMobile                     from './img/Mobile-Auto.jpg';
import Logos                                  from './img/Logos.png'
import LexyTeaserMobile                       from './img/Lexy-Roxx-700.jpg';
import {AppConsumer, AppProvider}             from './App.context';
import SocialMediaPosts                       from './SocialMediaPosts';
import Helpers                                from './Helpers';
import ScrollToTop                            from './ScrollToTop';
import TermsPage                              from "./TermsPage";

// combined curation feed url
const feedUrl = 'https://api.curator.io/v1/feeds/c9cd81ed-1157-418b-8778-e11227b5b1ae/posts?limit=100';

const StartPage = () => (
	<AppConsumer>
		{({links}) => (
			<div className="startpage_contents">
				<div className="startpage-contents_images">
					<div className="startpage_contents-mysteryauto">
						<img className="startpage_contents-mysteryauto--image" src={MysteryAuto} alt="Tickets kaufen" />
						<div className="startpage_contents-mysteryauto--overlay">
						</div>
					</div>
					<div className="startpage_contents-categories">
						<div className="startpage_contents-category1">
							<a href={links.PHOTOS} rel="noopener noreferrer" target="_blank">
								<img className="startpage_contents-category1--image" src={Category1} alt="Fotos" />
								<div className="startpage_contents-category--overlay">
									<p className="startpage_contents-category1--text">Fotos</p>
								</div>
							</a>
						</div>
						<div className="startpage_contents-category2">
							<a href={links.VIDEOS} rel="noopener noreferrer" target="_blank">
								<img className="startpage_contents-category2--image" src={Category2} alt="Videos" />
								<div className="startpage_contents-category--overlay">
									<p className="startpage_contents-category2--text">Videos</p>
								</div>
							</a>
						</div>
					</div>
					<div className="startpage_contents-teaser">
						<div className="startpage_contents-teaser--background">
							<img className="startpage_contents-teaser--image" src={LexyTeaser} alt="Lexy360" />
							<img className="startpage_contents-teaser--image_mobile" src={LexyTeaserMobile} alt="Lexy360" />
						</div>
						<div className="startpage_contents-teaser--text">Schau Dir meine Tuning-Serie an!</div>
						<div className="startpage_contents-teaser--text_mobile">Schau Dir meine Serie LEXY360!</div>
						<a href={links.MEDIATHEK}
						   rel="noopener noreferrer"
						   className="startpage_contents-teaser--button-container">
							<div className="startpage_contents-teaser--button">Lexy360 anschauen</div>
						</a>
					</div>
					<SocialMediaPosts initialItemsToShow={4} initialItemsToShowMobile={1} />
					<div className="roxxracing_socialposts-content--button-container">
						<Link to={Helpers.routes.News} className="roxxracing_socialposts-content--button-link">
							<div className="roxxracing_socialposts-content--button">Mehr sehen</div>
						</Link>
					</div>
				</div>
			</div>
		)}
	</AppConsumer>
);

class App extends Component {
	render() {
		const isMobile = Helpers.isMobile();

		return (
			<AppProvider feedUrl={feedUrl}>
				<div className="roxxracing_container">
					<VXHeader />
					<RRHeader />
					<Router>
						<ScrollToTop>
							<div>
								<Navi />
								<div>
									<Route exact path={Helpers.routes.Startpage} component={isMobile ? TicketsPage : StartPage} />
									{isMobile && <Route exact path={Helpers.routes.StartpageMobile} component={StartPage} />}
									<Route exact path={Helpers.routes.Tickets} component={TicketsPage} />
									<Route exact path={Helpers.routes.News} component={NewsPage} />
									<Route exact path={Helpers.routes.TermsPage} component={TermsPage} />
								</div>
							</div>
						</ScrollToTop>
					</Router>
					<VXFooter />
				</div>
			</AppProvider>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js